var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Consultant-Admin-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Consultant-Admin-view---v1.2",
    transform: "translate(-284.000000, -819.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(65.000000, 808.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Search",
    transform: "translate(216.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "24pt-Bounding-Box",
    opacity: 0,
    fillRule: "nonzero",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.71,19.29 L17.31,15.9 L17.3099999,15.9000001 C18.4069799,14.5024501 19.0022099,12.7766601 18.9999999,11.0000001 L18.9999999,11.0000001 C18.9999999,6.58172009 15.4182799,3.00000009 10.9999999,3.00000009 C6.58171993,3.00000009 2.99999993,6.58172009 2.99999993,11.0000001 C2.99999993,15.4182801 6.58171993,19.0000001 10.9999999,19.0000001 L10.9999999,19.0000001 C12.7766603,19.0022094 14.5024503,18.4069841 15.9000003,17.3100001 L19.2900003,20.7100001 L19.2900003,20.7100001 C19.6789203,21.1021221 20.3120803,21.1047181 20.7042003,20.7157984 C20.706141,20.7138736 20.7080738,20.7119408 20.7099986,20.7100001 L20.7099987,20.7100001 C21.1021207,20.3210801 21.1047167,19.6879201 20.7157969,19.2958001 C20.7138721,19.2938594 20.7119393,19.2919266 20.7099986,19.2900018 L20.71,19.29 Z M4.99999974,11.0000009 L4.99999974,11.0000009 C4.99999974,7.68629091 7.68629,5.00000091 10.9999997,5.00000091 C14.31371,5.00000091 16.9999997,7.68629091 16.9999997,11.0000009 C16.9999997,14.3137109 14.31371,17.0000009 10.9999997,17.0000009 L10.9999997,17.0000009 C7.68628974,17.0000009 4.99999974,14.3137109 4.99999974,11.0000009 C4.99999974,11.0000009 4.99999974,11.0000009 4.99999974,11.0000009 L4.99999974,11.0000009 Z",
    id: "Fill",
    fill: "#003d79"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.684a2c9d740dd225cc67ba6ae57d25d6.svg";
export { ForwardRef as ReactComponent };